<template>
    <confirm
        ref="confirmDialog"
        :confirmText="$t('dialogs-confirm.buttons.remove')"
        confirmColor="red darken-1"
    ></confirm>
</template>

<script>
import Confirm from './Confirm'
export default {
    components: {
        Confirm,
    },

    computed: {
        title() {
            return this.$t('actions.delete.title')
        },
    },

    methods: {
        async open(model, resourceName) {
            let confirmed = await this.$refs.confirmDialog.open(
                this.title,
                this.$t('actions.delete.text', {
                    name: resourceName ? resourceName : 'Recurso',
                }),
            )

            if (!confirmed) return

            let res = await model.delete()

            if (!res) return

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: 'Registro',
                }),
            )
        },

        //método legado onde o delete deve ser implementado no component pai
        confirm(itemName) {
            return this.$refs.confirmDialog.open(
                this.title,
                this.$t('actions.delete.text', {
                    name: itemName,
                }),
            )
        },
    },
}
</script>

<style></style>
